import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type GameStatus = 'menu' | 'lobby' | 'playing' | 'finished';
export type StressLevel = 'calm' | 'nervous' | 'panic';

export interface Player {
  id: string;
  name: string;
  isHost: boolean;
  stressLevel: StressLevel;
  isActive: boolean;
}

export interface RoomState {
  id: string;
  hostId: string;
  status: GameStatus;
  currentRound: number;
  currentTotal: number;
  targetTotal: number;
  players: Player[];
  myNumberOptions?: [number, number];
  hasSelected: boolean;
  roundTimeRemaining: number;
}

interface GameStore {
  playerName: string;
  playerId: string | null;
  currentRoom: RoomState | null;
  
  setPlayerName: (name: string) => void;
  setPlayerId: (id: string) => void;
  setCurrentRoom: (room: RoomState | null) => void;
  updateRoom: (updates: Partial<RoomState>) => void;
  reset: () => void;
}

export const useGameStore = create<GameStore>()(
  persist(
    (set) => ({
      playerName: '',
      playerId: null,
      currentRoom: null,
      
      setPlayerName: (name) => set({ playerName: name }),
      setPlayerId: (id) => set({ playerId: id }),
      setCurrentRoom: (room) => set({ currentRoom: room }),
      updateRoom: (updates) => set((state) => ({
        currentRoom: state.currentRoom ? { ...state.currentRoom, ...updates } : null
      })),
      reset: () => set({ playerName: '', playerId: null, currentRoom: null }),
    }),
    {
      name: 'game-session-storage',
      partialize: (state) => ({
        playerName: state.playerName,
        playerId: state.playerId,
        currentRoom: state.currentRoom,
      }),
    }
  )
);
